export const LOCALE_CONFIG = {
    BASE_REF_SUFFIX: '',
    APP_LOCALE: 'en-CA'
};
